<template>
    <span>
        <template v-if="type === 'store'">
            <i class="fas fa-store" style="color:#139911"></i>
        </template>
        <template v-else-if="type === 'short_channel'">
            <i class="fas fa-carrot" style="color:#ffce1e"></i>
        </template>
        <template v-else-if="type === 'customer_group'">
            <i class="fas fa-people-group" style="color:#6c757d"></i>
        </template>
        <template v-else-if="type === 'pickup_point'">
            <i class="fas fa-hammer" style="color:#ff781e"></i>
        </template>
        <template v-else-if="type === 'pickup_point_subcustomer'">
            <i v-if="online" class="fas fa-globe-europe" style="color:#1e90ff"></i>
            <i v-else class="fas fa-hand-paper" style="color:#ff781e"></i>
        </template>
        <template v-else>
            <i class="fas fa-question-circle" style="color:darkred"></i>
        </template>
    </span>
</template>

<script>
    export default {
        name: 'OrderIcon',

        props: {
            type: {
                type: String,
                required: true,
            },
            online: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
    }
</script>

<style scoped>

</style>
